export default "__VITE_ASSET__Be32YmX0__"